import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    ripple_container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
    },
});

export default useStyles;
